import { Action as AdvisoryAction, AdvisoryContent } from "../../../common/global-types/AdvisoryContent";
import useTracking from "../../../common/tracking/useTracking";
import IconedList from "../../../common/components/iconed-list/IconedList";
import Headline from "../../../common/components/headline/Headline";
import Paragraph from "../../../common/components/paragraph/Paragraph";
import Tagline from "../../../common/components/tagline/Tagline";
import Action from "../../../common/components/action/Action";

type BlockProps = {
  content: AdvisoryContent;
  viewId: number | undefined;
  dispatchActionEvent: (action: AdvisoryAction) => void;
};

function Block({ content, viewId, dispatchActionEvent }: BlockProps) {
  const trackVisibilityElement = useTracking(content, viewId);
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;

  if (view === undefined) return null;

  const actions: JSX.Element[] = [];
  const texts: JSX.Element[] = [];
  let trackElement = true;

  for (let index = 0; index < (view.viewElements.texts || []).length; index++) {
    const text = view.viewElements.texts?.[index];

    if (!text) return;

    if (text.type === 'paragraph') {
      texts.push(
        <Paragraph key={text.type + text.value} text={text} />
      );
    }
    if (text.type === 'headline') {
      texts.push(
        <Headline key={text.type + text.value} text={text} ref={trackElement ? trackVisibilityElement : undefined} />
      );

      trackElement = false;
    }
    if (text.type === 'list') {
      const listItems = view.viewElements.texts?.filter((text) => text.type === 'list') || [];

      texts.push(
        <IconedList key={text.type + text.value} texts={listItems} />
      );

      index += listItems.length - 1;
    }
    if (text.type === 'tagline') {
      texts.push(
        <Tagline key={text.type + text.value} text={text} />
      );
    }
  }

  (view.viewElements.actions || []).forEach((action) => {
    actions.push(
      <Action 
        key={action.text}
        action={action}
        dispatchActionEvent={dispatchActionEvent}
      />
    );
  });
  
  return (
    <div id="advisory-block" className="if card elevated">
      <div className="if card-content">
        {texts}
        {actions}
      </div>
    </div>
  );
};

export default Block;